const styles = {
  paletteContainer: (isExpanded: boolean) => ({
    width: isExpanded ? '280px' : '40px',
    height: '100%',
    backgroundColor: 'background.paper',
    borderLeft: '1px solid',
    borderColor: 'divider',
    overflow: 'hidden',
    flexShrink: 0,
    transition: (theme: any) =>
      theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }),
  toggleTab: {
    width: '100%',
    height: '100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: 'white',
    borderBottom: '1px solid',
    borderColor: 'divider',
    zIndex: 1001,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)'
    }
  },
  toggleButton: {
    color: 'text.primary',
    padding: '2px',
    transition: (theme: any) =>
      theme.transitions.create('transform', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
    '& svg': {
      transition: (theme: any) =>
        theme.transitions.create('transform', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  tabTextVertical: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: 'text.secondary',
    marginTop: '8px',
    writingMode: 'vertical-rl',
    textOrientation: 'mixed',
    letterSpacing: '1px'
  },
  tabTextHorizontal: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: 'text.secondary',
    marginTop: '8px',
    letterSpacing: '1px'
  },
  paletteContent: {
    flex: 1,
    padding: '16px',
    overflow: 'hidden auto',
    scrollbarWidth: 'thin'
  },
  nodeListContainer: (isExpanded: boolean) => ({
    opacity: isExpanded ? 1 : 0,
    transition: 'opacity 0.5s',
    pointerEvents: isExpanded ? 'auto' : 'none'
  }),
  paletteTitle: {
    marginBottom: '16px',
    color: 'text.primary',
    fontWeight: 600
  },
  nodeList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  }
};

export default styles;
